import api from "config/axios.config";
import { IClient } from "types/client.type";

export async function getClients(select?: string): Promise<IClient> {
  const clientId = process.env.REACT_APP_CLIENT_ID;
  return api.get(
    `clients/${select ? `${clientId}?select=${select}` : clientId}`
  );
}
